export function supportBigInt() {
  return typeof BigInt === 'function';
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@rc-component/mini-decimal/es/supportUtil.js
// module id = 770
// module chunks = 0